"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEndpoint = exports.SiteEndpoint = exports.SinkEndpoint = exports.ReportsEndpoint = exports.ProviderEndpoint = exports.PrescribeEndpoint = exports.PaymentEndpoint = exports.PatientEndpoint = exports.PadEndpoint = exports.OrderEndpoint = exports.NDCEndpoint = exports.LedgerEndpoint = exports.InventoryOrderEndpoint = exports.InventoryEndpoint = exports.ICD10Endpoint = exports.GoogleEndpoint = exports.FinancialsEndpoint = exports.EobEndpoint = exports.DashboardEndpoint = exports.BillingEndpoint = exports.AssetApprovalsEndpoint = exports.AuditLoggerEndpoint = exports.AppSettingsEndpoint = void 0;
const AppSettingsEndpoint = require("api/app-settings/app-settings-client");
exports.AppSettingsEndpoint = AppSettingsEndpoint;
const AssetApprovalsEndpoint = require("api/asset-approvals/asset-approvals-client");
exports.AssetApprovalsEndpoint = AssetApprovalsEndpoint;
const AuditLoggerEndpoint = require("api/audit-logger/audit-logger-client");
exports.AuditLoggerEndpoint = AuditLoggerEndpoint;
const BillingEndpoint = require("api/billing/billing-client");
exports.BillingEndpoint = BillingEndpoint;
const DashboardEndpoint = require("api/dashboard/dashboard-client");
exports.DashboardEndpoint = DashboardEndpoint;
const EobEndpoint = require("api/eob/eob-client");
exports.EobEndpoint = EobEndpoint;
const FinancialsEndpoint = require("api/financials/financials-client");
exports.FinancialsEndpoint = FinancialsEndpoint;
const GoogleEndpoint = require("api/google/google-client");
exports.GoogleEndpoint = GoogleEndpoint;
const ICD10Endpoint = require("api/icd10/icd10-client");
exports.ICD10Endpoint = ICD10Endpoint;
const InventoryEndpoint = require("api/inventory/inventory-client");
exports.InventoryEndpoint = InventoryEndpoint;
const InventoryOrderEndpoint = require("api/inventory-order/inventory-order-client");
exports.InventoryOrderEndpoint = InventoryOrderEndpoint;
const LedgerEndpoint = require("api/ledger/ledger-client");
exports.LedgerEndpoint = LedgerEndpoint;
const NDCEndpoint = require("api/ndc/ndc-client");
exports.NDCEndpoint = NDCEndpoint;
const OrderEndpoint = require("api/order/order-client");
exports.OrderEndpoint = OrderEndpoint;
const PadEndpoint = require("api/pad/pad-client");
exports.PadEndpoint = PadEndpoint;
const PatientEndpoint = require("api/patient/patient-client");
exports.PatientEndpoint = PatientEndpoint;
const PaymentEndpoint = require("api/payment/payment-client");
exports.PaymentEndpoint = PaymentEndpoint;
const PrescribeEndpoint = require("api/prescribe/prescribe-client");
exports.PrescribeEndpoint = PrescribeEndpoint;
const ProviderEndpoint = require("api/provider/provider-client");
exports.ProviderEndpoint = ProviderEndpoint;
const ReportsEndpoint = require("api/reporting/reporting-client");
exports.ReportsEndpoint = ReportsEndpoint;
const SinkEndpoint = require("api/sink/sink-client");
exports.SinkEndpoint = SinkEndpoint;
const SiteEndpoint = require("api/site/site-client");
exports.SiteEndpoint = SiteEndpoint;
const UserEndpoint = require("api/user/user-client");
exports.UserEndpoint = UserEndpoint;
__exportStar(require("./is-error"), exports);



//////////////////
// WEBPACK FOOTER
// ./src/client/api/index.ts
// module id = 65
// module chunks = 0 1 2